/* tslint:disable:interface-name */

import { PayVault } from '../api/payVault/payVaultAPI';

declare interface ExtendedWindow extends Window {
    payvault: PayVault;
    RAT: any;
}

const WINDOW: ExtendedWindow = window;

export default WINDOW;
